export default {
  API_BASE_URL: 'https://api-staging.didomi.io',
};
